
import { SearchOption } from './types';

export const searchOptions: SearchOption[] = [
  { value: 'full_name', label: 'Full Name' },
  { value: 'dob', label: 'DOB' },
  { value: 'mobile_phone_number', label: 'Mobile Number' },
  { value: 'home_phone_number', label: 'Home Number' },
  { value: 'email', label: 'Email' },
  { value: 'clinic_name', label: 'Clinic Name' },
  { value: 'provider_name', label: 'Provider Name' },
  { value: 'emr_id', label: 'EMR' }
];
